import theme from 'theme';

/**
 * Common X-axis scale configuration shared across all energy chart cards.
 */
export const xScaleConfig = {
  ticks: {
    color: theme.colors?.gray?.[7] as string | undefined,
    maxRotation: 90,
    minRotation: 45,
  },
  grid: { display: false },
};

/**
 * Common Y-axis grid configuration.
 */
export const yGridConfig = {
  color: 'rgba(0, 0, 0, 0.05)',
};

/**
 * Formats a numeric value as euros with 4 decimal places.
 *
 * @param value - The value to format.
 */
export const formatEur4 = (value: number | string): string => `${Number(value).toFixed(4)} €`;

/**
 * Formats a numeric value as euros with 2 decimal places.
 *
 * @param value - The value to format.
 */
export const formatEur2 = (value: number | string): string => `${Number(value).toFixed(2)} €`;

/**
 * Common bar dataset base properties.
 */
export const barDatasetBase = {
  borderRadius: 5,
  borderSkipped: false as const,
  barPercentage: 0.9,
};
